import { useFormik } from "formik";
import ModalComponent from "..";
import { ModalCompProps } from "../../../utils/types";
import { HolidaySchema } from "../../../utils/validations";
import { Button } from "../../buttons/button";
import { TextInput } from "../../inputs/textInput";
import { DateInput } from "../../inputs/dateInput";
import { parseDateStringToDate } from "../../../utils/helpers";
import moment from "moment";

export const AddHolidayModal = ({
  open,
  handleClose,
  onContinue,
  initialValues,
}: ModalCompProps & {
  onSuccess: () => void;
  onContinue: (vals: {
    name: string;
    holidayDate: string;
    nextWorkingDay: string;
  }) => void;
  initialValues: {
    name: string;
    holidayDate: string;
    nextWorkingDay: string;
  };
}) => {
  const {
    values,
    errors,
    touched,
    handleBlur,
    setFieldValue,
    handleSubmit,
    handleChange,
    resetForm,
    isValid,
  } = useFormik({
    initialValues,
    enableReinitialize: true,
    validationSchema: HolidaySchema,
    onSubmit: async (vals) => {
      onContinue(vals);
    },
  });

  return (
    <ModalComponent
      open={open}
      handleClose={() => {
        handleClose();
        resetForm();
      }}
      className=""
      dialogClassName=""
      closeOnOverlayClick
      showHeader
      title={"Add Public Holiday"}
      subtitle={undefined}
      showIcon={true}
      iconType="beach"
      showBackIcon={false}
      mobileAnchorBottom
      showCloseIcon={false}
    >
      <form onSubmit={handleSubmit} className="grid grid-cols-2 gap-4">
        <TextInput
          type="text"
          name="name"
          value={values.name}
          placeholder="Enter holiday name"
          onChange={handleChange}
          onBlur={handleBlur}
          hasTitle
          title="Name"
          errors={errors.name && touched.name ? errors.name : ""}
          containerClassName="col-span-full"
        />
        <DateInput
          name="holidayDate"
          onBlur={handleBlur}
          placeholder="Choose Holiday Date"
          errors={
            errors.holidayDate && touched.holidayDate ? errors.holidayDate : ""
          }
          title="Holiday Date"
          date={parseDateStringToDate(values.holidayDate, undefined, true)}
          setDate={(date) => {
            setFieldValue(
              "holidayDate",
              date ? new Date(date).toISOString() : "",
            );
          }}
        />

        <DateInput
          name="nextWorkingDay"
          onBlur={handleBlur}
          placeholder="Choose working day"
          errors={
            errors.nextWorkingDay && touched.nextWorkingDay
              ? errors.nextWorkingDay
              : ""
          }
          title="Next Working Day"
          date={parseDateStringToDate(values.nextWorkingDay, undefined, true)}
          minDate={
            values.holidayDate !== ""
              ? moment(values.holidayDate).add(1, "day")
              : undefined
          }
          setDate={(date) => {
            setFieldValue(
              "nextWorkingDay",
              date ? new Date(date).toISOString() : "",
            );
          }}
        />

        <div className="col-span-full flex items-center justify-end gap-2">
          <Button
            text={"Cancel"}
            type="button"
            onClick={() => {
              handleClose();
              resetForm();
            }}
            variation="plain-grey"
            className="max-w-fit"
          />
          <Button
            text={"Continue"}
            type="submit"
            className="max-w-fit"
            loading={false}
            disabled={!isValid}
            variation={"primary"}
          />
        </div>
      </form>
    </ModalComponent>
  );
};
